import * as Sentry from "@sentry/browser";

/* eslint-disable */

// The helpers.js code will contain all the codes that appear over and over in the project

import {
  requestOptionsGet,
  requestOptionsPost,
  requestOptionsPut,
} from "./config.js";
import { TIMEOUT_SEC } from "./config.js";

const timeout = function (s) {
  return new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

export const getJSON = async function (url) {
  try {
    const fetchPro = fetch(url, requestOptionsGet);
    // Starts an HTTP request to 'product' URL.
    const res = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);

    // Return data as JSON object
    const data = await res.json();

    // Throw a user-defined exception
    if (!res.ok) {
      throw new Error(`${data.message} (${res.status})`);
    }

    return data;
  } catch (err) {
    // Capture and send the error to Sentry
    Sentry.captureException(err);

    throw err;
  }
};

export const sendJSON = async function (url, body) {
  try {
    requestOptionsPost.body = JSON.stringify(body);

    const fetchPro = fetch(url, requestOptionsPost);

    // Starts an HTTP request to 'cart' URL.
    const res = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);

    // Return data as JSON object
    const data = await res.json();

    // Throw a user-defined exception
    if (!res.ok) {
      // Create error with full response data attached
      const error = new Error(`${data.message} (${res.status})`);
      error.response = data;
      error.statusCode = res.status;
      throw error;
    }

    return data;
  } catch (err) {
    // Capture and send the error to Sentry
    Sentry.captureException(err);

    throw err;
  }
};

export const putJSON = async function (url, product) {
  try {
    requestOptionsPut.body = JSON.stringify(product);

    const fetchPro = fetch(url, requestOptionsPut);

    // Starts an HTTP request to 'cart' URL.
    const res = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);

    // Return data as JSON object
    const data = await res.json();

    // Throw a user-defined exception
    if (!res.ok) {
      throw new Error(`${data.message} (${res.status})`);
    }

    return data;
  } catch (err) {
    // Capture and send the error to Sentry
    Sentry.captureException(err);

    throw err;
  }
};

// Formats an address string by combining address and city, filtering out empty values.
export const formatAddress = function (address, city) {
  return [address, city].filter(Boolean).join(", ");
};

/* eslint-enable */
